// Global
export const TOGGLE_SPINNER = '⏲ Toggle Spinner';

// auth.js
export const LOGOUT = '🚪 Logout'
export const SAVE_TOKEN = '🔒 Save Token'
export const FETCH_USER_SUCCESS = '👱✅ Fetch User Successful'
export const FETCH_USER_FAILURE = '👱❌ Fetch User Failed'

// users.js
export const DELETE_USER =  '👱➖ Delete User';
export const FETCH_USERS_FAILED = '👱❌ Fetch Users Failed';
export const FETCH_USERS_SUCCESS = '👱✅ Fetch Users Successful';

// posts.js
export const DELETE_POST =  '📝➖ Delete Post';
export const FETCH_POSTS_FAILED = '📝❌ Fetch Posts Failed';
export const FETCH_POSTS_SUCCESS = '📝✅ Fetch Posts Successful';

// pets.js
export const FETCH_PETS_FAILED = '🐕❌ Fetch Pets Failed';
export const FETCH_PETS_SUCCESS = '🐕✅ Fetch Pets Successful';
export const FETCH_PET_OF_THE_WEEK_FAILED = '🐕❌ Fetch Pet of the week Failed';
export const FETCH_PET_OF_THE_WEEK_SUCCESS = '🐕✅ Fetch Pet of the week Successful';

export const FETCH_POSTS_PENDING_FAILED = '📝❌ Fetch Posts Failed';
export const FETCH_POSTS_PENDING_SUCCESS = '📝✅ Fetch Posts Successful';
export const BAN_POST =  '📝➖ Ban Post';
export const UNBAN_POST =  '📝➖ UnBan Post';

export const FETCH_USERS_PENDING_FAILED = '👱❌ Fetch Users Failed';
export const FETCH_USERS_PENDING_SUCCESS = '👱✅ Fetch Users Successful';
export const BAN_USER =  '👱➖ Ban User';
export const UNBAN_USER =  '👱➖ UnBan User';



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js